'use client';

import React, { Suspense } from 'react';
import { useSearchParams } from 'next/navigation';
import { Box, Button, Paper, Typography, Alert, Divider } from '@mui/material';

/**
 * Pagina di accesso dell'applicazione.
 *
 * Non raccoglie credenziali: mostra soltanto il punto di ingresso verso
 * l'identity provider. Le password si inseriscono unicamente sul form di
 * Keycloak, come richiede il contratto di integrazione SSO.
 *
 * Esiste perche' saltare direttamente all'IdP disorienta: chi arriva non sa su
 * quale applicazione sta entrando ne' con quale identita'.
 */
function LoginContent() {
  const searchParams = useSearchParams();

  // Dove tornare dopo l'accesso. La destinazione viene comunque rivalidata dal
  // backend contro gli host conosciuti, quindi non e' un vettore di redirect.
  const returnTo = searchParams.get('return_to') ?? '';
  const error = searchParams.get('error');

  const loginHref = returnTo
    ? `/auth/login?return_to=${encodeURIComponent(returnTo)}`
    : '/auth/login';

  return (
    <Box
      component="main"
      sx={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        px: 2,
        bgcolor: 'background.default',
      }}
    >
      <Paper elevation={2} sx={{ p: { xs: 3, sm: 5 }, maxWidth: 440, width: '100%', textAlign: 'center' }}>
        <Typography variant="h5" component="h1" gutterBottom>
          SportStack
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Gestione competizioni sportive
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 3, textAlign: 'left' }}>
            Accesso non riuscito. Riprova, e se il problema persiste contatta un amministratore.
          </Alert>
        )}

        <Divider sx={{ mb: 3 }} />

        <Button
          variant="contained"
          size="large"
          fullWidth
          href={loginHref}
          sx={{ py: 1.5, textTransform: 'none', fontSize: '1rem' }}
        >
          Accedi con Passione Bridge
        </Button>

        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 3 }}>
          Verrai reindirizzato al servizio di autenticazione Passione Bridge.
          Le credenziali non transitano da questa applicazione.
        </Typography>
      </Paper>
    </Box>
  );
}

export default function LoginPage() {
  // useSearchParams richiede un confine di Suspense in App Router.
  return (
    <Suspense fallback={null}>
      <LoginContent />
    </Suspense>
  );
}
